'use strict';

module.exports = {
    /**
     * 改变当前view导航样式
     * @method hysdk.navRefresh
     * @category Fusion:Navigation
     * @description
     * 只支持设置 title 和 right，并只支持 style 为 text。
     */
    navRefresh: {
        service: 'NavBar',
        action: 'refresh',
        tagname: 'refresh_nav_bar',
        optHandle: function optHandle(opt) {
            var o = {};
            if (opt.title && opt.title.style === 'text') {
                o.center = [{
                    tagname: 'title_click',
                    value: opt.title.text
                }];
            }
            if (opt.right && opt.title.style === 'text') {
                o.right = [{
                    tagname: 'right_click',
                    value: opt.right.text
                }];
            }
            return o;
        }
    },
    /**
     * 获取当前view导航状态，隐藏还是显示
     * @method hysdk.getNavDisplayStatus
     * @category Fusion:Navigation
     * @description
     * 与 Hy 环境用法、参数格式相同
     */
    getNavDisplayStatus: {
        exec: function exec(opt, callback) {
            callback({
                status: location.search.indexOf('isHideNavBar=YES') > -1 ? 'showed' : 'hidden'
            });
        }
    },
    /**
     * 设置当前view导航状态，隐藏或者显示（仅仅在设置有导航栏的情况下有效）
     * @method hysdk.setNavDisplayStatus
     * @category Fusion:Navigation
     * @description
     * 与 Hy 环境用法、参数格式相同
     */
    setNavDisplayStatus: {
        service: 'NavBar',
        action: 'setNavBarHidden',
        tagname: 'set_navbar_hidden',
        optHandle: function optHandle(opt) {
            opt.isHidden = opt.action === 'hide';
            return opt;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../plugins/ctrip/apis/navigation.js
// module id = 49
// module chunks = 1 4